const ReservationInfoWrapper = ({children}) => {
  return (
      <div className={"col-xl-6 mb-4"}>
      <div className="border rounded py-3 px-3 h-100 d-flex bg-white">
          {children}
      </div>
      </div>
  )
}
export default ReservationInfoWrapper;